import { useEffect } from "react"
import { DadosContainerDefault } from "../../components/Styles"
import SuportePage from "../../components/Suporte"

function Suporte () {

    useEffect (() => {
        document.title = 'Suporte | Gesttor'
    }, [])
    
    return (
        <DadosContainerDefault>
            <SuportePage />
        </DadosContainerDefault>
    )
}

export default Suporte
